export { default as DetailsContainer } from './details-container';